import React, { useEffect } from 'react';
import { Enlog } from '@encarpkg/shared';
import { Modal } from '@encarpkg/design';

function LayerInquiryComplete({ onClickOk }) {
	useEffect(() => {
		const dataTalkViewSingle = {
			eventnamegroup: '구매문의완료',
		};
		Enlog().enloggingJsonData({
			dataTalkViewSingle,
		});
	}, []);

	return (
		<Modal
			isOpen
			dimClosable
			title="문의완료"
			subtitle={
				<>
					판매자에게 문의를 남겼어요.
					<br />
					채팅은 앱에서만 답변을 확인할 수 있어요
				</>
			}
			onClickOk={onClickOk}
			data-enlog-dt-eventnamegroup="구매문의완료"
			okText="확인"
		/>
	);
}

export default LayerInquiryComplete;
